import strings from 'strings';

export const COPIES = strings.ai.generators.roleplay;

export const FORM_FIELDS_MAP = {
  Specialty: { key: 'specialty' },
  Subspecialty: { key: 'subspecialty' },
  Title: { key: 'title' },
  Difficulty: { key: 'difficulty' }
};

export const CALL_GOALS = [
  COPIES.scenarios.callHiringAuthority.goals.confirmHiringAuthorityInterest,
  COPIES.scenarios.callHiringAuthority.goals.gatherJobOrderInformation,
  COPIES.scenarios.callHiringAuthority.goals.obtainFeeAgreementSignature
];
